import { FocusRoom } from '@/components/features/wellbeing/focus/FocusRoom';

/** /wellbeing/focus - the Pomodoro timer, on a page of its own. */
export function FocusRoomPage() {
  return <FocusRoom />;
}
